import { ref } from 'vue';
import { useSnackbarStore } from '@/stores/snackbarInfo';
import { unsupportedImageMessage } from '@fundeasy/storage';

export function usePhotoService() {
  const imgObj = ref(null);
  const fileName = ref(null);
  const imgBase64 = ref(null);
  const fileType = ref(null);
  const fileSize = ref(null);
  const error = ref(null);

  const processPhoto = (file) => {
    if (file) {
      error.value = null;

      const rejection = unsupportedImageMessage(file);

      if (rejection) {
        error.value = rejection;

        // Resolved lazily so processPhoto stays callable outside a component setup context.
        useSnackbarStore().setSnackbar(rejection, 'error', 5000);

        return false;
      }

      fileName.value = file.name;
      imgObj.value = URL.createObjectURL(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        imgBase64.value = reader.result;
        fileType.value = file.type;
        fileSize.value = file.size;
      };

      return true;
    }

    return false;
  };

  const loadFromServer = async (endpoint) => {
    const imgReq = await fetch(`${endpoint}?t=${Date.now()}`);

    if (imgReq.ok) {
      const splitBannerPath = endpoint?.split('/') ?? [];
      const imgData = await imgReq.blob();

      imgObj.value = URL.createObjectURL(imgData);

      const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      };

      imgBase64.value = await blobToBase64(imgData);
      fileType.value = imgData.type;
      fileName.value = splitBannerPath[splitBannerPath.length - 1];
    }
  };

  const resetPhoto = () => {
    imgObj.value = null;
    fileName.value = null;
    imgBase64.value = null;
    fileType.value = null;
    fileSize.value = null;
    error.value = null;
  };

  return {
    imgObj,
    fileName,
    imgBase64,
    fileType,
    processPhoto,
    loadFromServer,
    resetPhoto,
    fileSize,
    error,
  };
}
